(() => {
  function init(root) {
    if (root.dataset.ilPdpReady) return;
    root.dataset.ilPdpReady = 'true';
    const bar = root.querySelector('[data-il-sticky]');
    const action = root.querySelector('[data-il-sticky-action]');
    const primary = root.querySelector('[data-il-purchase-action]');
    const price = root.querySelector('[data-product-price]');
    const stickyPrice = root.querySelector('[data-il-sticky-price]');
    const sync = () => { if (price && stickyPrice) stickyPrice.textContent = price.textContent; };
    if (price) new MutationObserver(sync).observe(price, {childList:true,subtree:true,characterData:true});
    if (bar && primary) new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, {threshold:0}).observe(primary);
    action?.addEventListener('click', () => {
      const panel = root.querySelector('.il-pdp__panel');
      panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      const control = panel.querySelector('input[type="radio"]:checked, [data-add-to-cart], #open-request-price');
      control?.focus({preventScroll:true});
    });
    const updateSpecifications = () => {
      const editorial = document.querySelector(`.il-editorial[data-product-id="${root.dataset.productId}"]`);
      if (!editorial) return;
      const options = Array.from(root.querySelectorAll('[data-option-position]')).map((wrapper) => wrapper.querySelector('input:checked, input[type="hidden"][data-single-option-selector], select')?.value).filter(Boolean);
      const finish = options.find((value) => /^(White|Rose|Yellow)( Gold)?$/.test(value));
      const material = options.find((value) => /^(925 Silver|14k Gold) \+ /.test(value));
      const metal = material?.startsWith('925 Silver') ? '925 Silver' : finish ? `14k ${finish.replace(/ Gold$/, '')} Gold` : null;
      if (metal) editorial.querySelectorAll('[data-il-spec-metal]').forEach((node) => { node.textContent = metal; });
      if (material) editorial.querySelectorAll('[data-il-spec-stones]').forEach((node) => { node.textContent = material.includes('Natural') ? 'Natural Diamonds' : 'Lab-Grown Diamonds'; });
    };
    root.addEventListener('theme:variant:change', () => { sync(); updateSpecifications(); });
    root.addEventListener('change', updateSpecifications);
    updateSpecifications();
    sync();
  }
  const boot = () => document.querySelectorAll('.il-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
